module.exports = __webpack_public_path__ + "static/media/grubhub-logo.092ff873.svg";